import coreStore from "./core-store";
import Axios from 'axios'

const remoteResource = 'processing/api/v1/job-schedules';

const store = coreStore.createCoreStore('jobSchedule', remoteResource);

export default store;
